import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(theme => ({
  cardBody: {
    padding: theme.spacing(0, 2),
  },
  description: {
    color: theme.palette.common.gray800,
    paddingBottom: theme.spacing(3),
  },
}));
